import { InvoiceCategory, InvoiceType } from "./constant"

export const ticketColumns = [
  {
    title: '发票类型',
    dataIndex: 'type',
    customRender: type => InvoiceType[type],
    width: 200,
    // ellipsis: true,
  },
  {
    title: '发票类别',
    dataIndex: 'category',
    customRender: category => InvoiceCategory[category],
    width: 200,
    // ellipsis: true,
  },
  {
    title: '发票抬头',
    dataIndex: 'title',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'titles' },
  },
  {
    title: '纳税人识别号',
    dataIndex: 'taxPayerId',
    width: 220,
    ellipsis: true,
    scopedSlots: { customRender: 'taxPayerId' },
  },
  {
    title: '开户名称',
    dataIndex: 'accountName',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'accountName' },
  },
  {
    title: '开户行',
    dataIndex: 'accountBank',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'accountBank' },
  },
  {
    title: '银行账号',
    dataIndex: 'account',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'account' },
  },
  {
    title: '单位地址',
    dataIndex: 'address',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'address' },
  }
]

export const taxRateColumns = [
  {
    title: '序号',
    type: 'index',
    customRender: ( text, cell ,index) => index + 1,
  },
  {
    title: '费目',
    dataIndex: 'costCode',
  },
  {
    title: '税率',
    dataIndex: 'taxRate',
    customRender: (text) => `${text * 100  }%`,
  },
]